<template>
    <div v-if="isVisible" class="popup-container">
        <div class="card white popup">
            <h2>{{ title ?? "Ajouter un moyen de paiement" }}</h2>
            <form id="payment-form">
                <div class="form-control">
                    <label for="card-number">Numéro de carte</label>
                    <div id="card-number" class="input-element"></div>
                </div>
                <div class="form-group">
                    <div class="form-control" style="margin-bottom: 0;">
                        <label for="card-expiry">Expiration</label>
                        <div id="card-expiry" class="input-element"></div>
                    </div>
                    <div class="form-control" style="margin-bottom: 0;">
                        <label for="card-cvc">CVC</label>
                        <div id="card-cvc" class="input-element"></div>
                    </div>
                </div>
                <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
                <div class="popup-actions">
                    <button class="button fill orange" @click="confirmAction" :disabled="isSubmitting">
                        {{ confirmButtonText }}
                    </button>
                    <button class="button outline orange" @click="cancelAction" :disabled="isSubmitting">
                        {{ cancelButtonText }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>


<script>
import { loadStripe } from '@stripe/stripe-js';

export default {
    name: "AjouterPaiement",
    props: {
        isVisible: Boolean,
        title: String,
        text: String,
        subID: String,
        confirmButtonText: {
            type: String,
            default: "Confirmer",
        },
        cancelButtonText: {
            type: String,
            default: "Annuler",
        },
    },
    data() {
        return {
            errorMessage: "",
            isSubmitting: false,
            stripe: null,
            cardNumber: null,
            cardExpiry: null,
            cardCvc: null,
            clientSecret: null,
            showPaymentPopup: false,
        };
    },
    async mounted() {
        try {
            const response = await fetch(process.env.VUE_APP_API_URL + "user/create-setup-intent", {
                method: "POST",
                credentials: "include",
                headers: { 'Content-Type': 'application/json', },
            });

            const result = await response.json();
            if (!response.ok) throw new Error(result.error || 'Failed to create setup intent');

            this.clientSecret = result.clientSecret;

            if (!this.clientSecret) throw new Error('Client secret is not available');

            this.stripe = await loadStripe('pk_live_51PzwDkJ56aDnMTeVx4lj7QS3bt5XxryuoL1RoI3Xo3mhzZmX7VSjVAv5kYQqpnc23lTgJaAQshOTtLu18x7XG9wu00tcCfMdWH');
        } catch (error) {
            console.error('Error in mounted:', error);
            this.errorMessage = error.message;
        }
    },
    methods: {
        async initializeStripeElements() {
            try {
                const elements = this.stripe.elements();
                this.cardNumber = elements.create('cardNumber');
                this.cardExpiry = elements.create('cardExpiry');
                this.cardCvc = elements.create('cardCvc');
                this.cardNumber.mount('#card-number');
                this.cardExpiry.mount('#card-expiry');
                this.cardCvc.mount('#card-cvc');
            } catch (error) {
                console.error('Error in initializeStripeElements:', error);
                this.errorMessage = error.message;
            }
        },
        async confirmAction() {
            this.isSubmitting = true;
            this.errorMessage = "";

            try {
                const { setupIntent, error } = await this.stripe.confirmCardSetup(
                    this.clientSecret, {
                    payment_method: {
                        card: this.cardNumber,
                    },
                });

                if (error) throw error;

                const response = await fetch(process.env.VUE_APP_API_URL + "user/attach-payment-method", {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', },
                    body: JSON.stringify({ paymentMethodId: setupIntent.payment_method, subID: this.subID }),
                });

                const result = await response.json();
                if (response.ok) {
                    this.$emit("confirm");
                } else {
                    throw new Error(result.error || 'Failed to attach payment method');
                }
            } catch (error) {
                this.errorMessage = error.message;
                console.error('Error in submitForm:', error);
            } finally {
                this.isSubmitting = false;
            }
        },
        resetForm() {
            this.cardNumber = null;
            this.cardExpiry = null;
            this.cardCvc = null;
            this.clientSecret = null;
        },
        cancelAction() {
            this.resetForm();
            this.$emit("cancel1");
        },
    },
    watch: {
        async isVisible(newVal) {
            if (newVal) {
                await this.$nextTick();
                this.initializeStripeElements();
            }
        }
    },
};
</script>

<style scoped>
.form-group {
    margin-bottom: 1rem;
}

.input-element {
    padding: 0.5rem;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 16px;
    width: 100%;
    box-sizing: border-box;
}

.error-message {
    color: #fa755a;
    margin-top: 0.5rem;
    font-size: 14px;
}
</style>
